import React, { useState } from 'react';
import { Heading, Text, Flex, Card, Box, Image, Button } from 'rebass';
import { Link } from 'react-router-dom';
import doctor from '../../static/Doctor_Female_White_shirt_2.png';
import discoverPossibleCauses from '../../static/Character_2.png';
import { MembershipBulletItem } from '../../components/MembershipBulletItem';
import { withWizard } from 'react-albus';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { isToggleActive } from '../../components/featureToggle/toggles';
import Modal, { BaseModalBackground } from 'styled-react-modal';
import { useMount } from '../../utils/hooks/lifecycle/useMount';
import { getMemberVisitPrice } from '../../utils/pricing';
import { Constants } from '../../utils/constants';
import BecomeMemberNew from '../becomeMemberNew';

const A = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  color: #44a5ff;
  text-decoration: underline;
  cursor: pointer;
`;

const FakeButton = styled(Box)`
  height: 40px;
  background: #354e79;
  border-radius: 20px;
  color: white;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
  margin-top: 24px;
  width: 250px;
`;
const SpecialModalBackground = styled(BaseModalBackground)`
  backdrop-filter: blur(5px);
`;

const BecomeAMember = ({ insuranceAccepted, insuranceForced, hasInNetwork }) => {
  const hasNewPriceFeature = isToggleActive('USE_NEW_PRICING');
  const t = isToggleActive('INSURANCE_MEMBERSHIP_WIND_DOWN');
  return (
    <>
      <Heading>Become a Member</Heading>
      <Text mt="8px" fontWeight="300">
        <span style={{ fontWeight: 600 }}>
          {!insuranceForced || !hasInNetwork || !!t ? (
            `$${isToggleActive('MEMBERSHIP_PRICE_2024') ? Constants.MEMBERSHIP_PRICE_2024 : Constants.MEMBERSHIP_PRICE}`
          ) : (
            <>
              <span
                style={{
                  textDecoration: 'line-through',
                }}
              >
                {`$${isToggleActive('MEMBERSHIP_PRICE_2024') ? Constants.MEMBERSHIP_PRICE_2024 : Constants.MEMBERSHIP_PRICE}`}
              </span>
              <span>&nbsp;$96</span>
            </>
          )}
        </span>{' '}
        billed annually
      </Text>

      {(!insuranceForced || !hasInNetwork || !!t) && (
        <quadpay-widget-v3
          amount={`${isToggleActive('MEMBERSHIP_PRICE_2024') ? Constants.MEMBERSHIP_PRICE_2024 : Constants.MEMBERSHIP_PRICE}`}
          merchantId={window._env_.REACT_APP_QUADPAY_MERCHANTID}
          alignment="left"
          widgetVerbiage="4-easy-payments"
        />
      )}
      {/* {(!insuranceForced || !hasInNetwork) && <zip-payment-widget amount= "192" merchantId={window._env_.REACT_APP_QUADPAY_MERCHANTID} > </zip-payment-widget>} */}
      {/* <quadpay-widget-v3 amount="192" alignment="left" widgetVerbiage="4-easy-payments" />} */}
      {!insuranceAccepted || !!t ? (
        <>
          <Flex flexDirection="row" style={{ marginTop: '4px' }}>
            <img src={doctor} height="77px" alt="" />
            <Flex flexDirection="column" justifyContent="flex-end">
              <Text style={{ fontWeight: 600 }}>Visit</Text>
              <Flex flexDirection="row" alignItems="baseline">
                {!isToggleActive('MEMBERSHIP_ONLY') && (
                  <Text
                    style={{
                      fontWeight: 600,
                      textDecoration: 'line-through',
                      marginRight: '6px',
                    }}
                  >
                    {`$${hasNewPriceFeature ? '110' : '99'}`}
                  </Text>
                )}
                <Text style={{ fontWeight: 600, fontSize: '20px' }}>
                  ${getMemberVisitPrice()}
                  {isToggleActive('MEMBERSHIP_ONLY') ? <span style={{ fontSize: '14px', fontWeight: 300 }}> cash or your copay</span> : ''}
                </Text>
              </Flex>
            </Flex>
          </Flex>
          <Text
            style={{
              fontWeight: 500,
              fontSize: '16px',
              marginTop: '28px',
              marginBottom: '16px',
            }}
          >
            And get access to:
          </Text>
          <MembershipBulletItem text="Dedicated Care manager" />
          <MembershipBulletItem text="Unlimited Doctor Chats" />
          <MembershipBulletItem text="Easy Refills " />
          <MembershipBulletItem text="Cancel Anytime" style={{ maxWidth: '150px' }} />

          <img
            alt=""
            src={discoverPossibleCauses}
            style={{
              position: 'absolute',
              bottom: '62px',
              right: '12px',
              width: '140px',
            }}
          />
          {/* {!isMobile && ( */}
          {/* <FakeButton>
            Join {isToggleActive('MEMBERSHIP_ONLY') ? 'to Book' : 'Now'}
          </FakeButton> */}
          {/* )} */}
        </>
      ) : (
        <>
          <Text mt="16px" fontWeight="300">
            The hypothyroid membership loaded with perks and discounts
          </Text>
          <Text
            style={{
              fontWeight: 500,
              fontSize: '16px',
              marginTop: '28px',
              marginBottom: '16px',
            }}
          >
            And get access to:
          </Text>
          <MembershipBulletItem style={{ width: '90%', marginBottom: '22px' }} text="Exclusive discounts on all our services and products" />
          <MembershipBulletItem style={{ width: '90%', marginBottom: '22px' }} text="Members-only resources and community" />
          <MembershipBulletItem style={{ width: '90%', marginBottom: '22px' }} text="Symptom tracker application" />
        </>
      )}
      <FakeButton>Join {isToggleActive('MEMBERSHIP_ONLY') ? 'to Book' : 'Now'}</FakeButton>
    </>
  );
};

const selectMembershipMultiMemberships = ({ wizard, onContinue, onSubscribe, insuranceAccepted, canSkip, isInNetwork, hasInNetwork, onGoBack, session }) => {
  const [isConfirmOutNetworkInsuranceModal, setIsConfirmOutNetworkInsuranceModal] = useState();
  console.log({ session });
  useMount(() => {
    console.log('Mount', { isInNetwork, hasInNetwork });
    setIsConfirmOutNetworkInsuranceModal(!isInNetwork && !!hasInNetwork);
  });
  const handleClose = () => {
    setIsConfirmOutNetworkInsuranceModal(false);
  };
  return (
    <BecomeMemberNew
      canWeightCareEssentials={true}
      onSelect={(membershipType) => {
        onSubscribe(membershipType);
      }}
      canCompleteHealthBoost={!session || !session.isMember}
      canHormoneRebalance={false}
      canMetabolicReset={!session || !session.isMember}
      isOnSchedule={true}
      canSkip={canSkip}
      onContinue={onContinue}
    />
  );
};

export default withWizard(selectMembershipMultiMemberships);
